<template>
  <div id="charging-report">
    <a-form class="ant-advanced-search-form" :form="form" @submit="getInfos">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="Select Date">
            <a-range-picker @change="onDateChange" v-decorator="['range-picker', rangeConfig]" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="Charger #">
            <a-input v-decorator="['chargerNumber']" placeholder="All chargers" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="Bus #">
            <a-input v-decorator="['busNumber']" placeholder="All buses" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8" v-if="!this.SingleCompanyUser">
          <a-form-item label="Company">
            <a-select
              @change="onCompanyChange"
              v-decorator="[
                'company',
                {
                  rules: [{ required: true, message: 'Please select a company!' }]
                }
              ]"
              :allowClear="true"
              placeholder="Select company"
            >
              <a-select-option v-for="(item, index) in displayCompanies" :key="index" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="Location">
            <a-select
              v-decorator="[
                'depot',
                {
                  initialValue: depotList.length == 1 ? depotList[0] : undefined
                }
              ]"
              :allowClear="true"
              placeholder="Select location"
              :disabled="depotDisabled"
            >
              <a-select-option v-for="(item, index) in depotList" :key="index" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8" :style="{ textAlign: 'right' }" :offset="getOffsetValue">
          <a-form-item>
            <a-button type="primary" html-type="submit">
              Generate Report
            </a-button>
            <vue-csv-downloader :data="handleData" :fields="fields" :download-name="csvName">
              <a-button :style="{ marginLeft: '8px' }" type="primary" icon="download" :disabled="downloadDisabled">
                Download CSV
              </a-button>
            </vue-csv-downloader>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <br />
    <div class="search-result-list">
      <a-table
        :columns="columns"
        :dataSource="handleData"
        :scroll="{ x: 1500, y: 1000 }"
        :loading="loading"
        :rowKey="(record, index) => index + 1"
        :pagination="{
          defaultPageSize: 20,
          showSizeChanger: true,
          position: 'both'
        }"
        @change="onTableChange"
        size="middle"
      >
        <template slot="footer">
          {{ this.numberOfRows + " Entries Found" }}
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import VueCsvDownloader from "vue-csv-downloader";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      downloadDisabled: true,
      depotDisabled: true,
      form: this.$form.createForm(this),
      rangeConfig: {
        rules: [{ type: "array", required: true, message: "Please select Date!" }]
      },
      startTime: "",
      endTime: "",
      csvName: "",
      depotList: [],
      data: [],
      fields: [],
      numberOfRows: 0,
      pageOffset: 0,
      columns: [
        {
          title: "Index",
          key: "index",
          dataIndex: "index",
          customRender: (text, record, index) => this.pageOffset + index + 1,
          align: "center",
          width: 80
        },
        {
          title: "Bus #",
          dataIndex: "busNumber",
          sorter: (recordOne, recordTwo) => {
            let numberOne, numberTwo;
            if (recordOne.busNumber == "Invalid_vin" || recordOne.busNumber == "Invalid_VIN") {
              numberOne = Number.MAX_SAFE_INTEGER - 1;
            } else if (recordOne.busNumber == "New VIN Found") {
              numberOne = Number.MAX_SAFE_INTEGER;
            } else {
              numberOne = recordOne.busNumber;
            }

            if (recordTwo.busNumber == "Invalid_vin" || recordTwo.busNumber == "Invalid_VIN") {
              numberTwo = Number.MAX_SAFE_INTEGER - 1;
            } else if (recordTwo.busNumber == "New VIN Found") {
              numberTwo = Number.MAX_SAFE_INTEGER;
            } else {
              numberTwo = recordTwo.busNumber;
            }
            return numberOne - numberTwo;
          },
          align: "center",
          width: 100
        },
        {
          title: "Odometer",
          dataIndex: "totalMileage",
          align: "center",
          width: 120
        },
        {
          title: "Charger #",
          dataIndex: "chargerNumber",
          sorter: (recordOne, recordTwo) => recordOne.chargerNumber - recordTwo.chargerNumber,
          align: "center",
          width: 120
        },
        {
          title: "Start Time",
          dataIndex: "startTime",
          sorter: (recordOne, recordTwo) => {
            let timeOne = new Date(recordOne.startTime);
            let timeTwo = new Date(recordTwo.startTime);
            return timeOne - timeTwo;
          },
          align: "center",
          width: 160
        },
        {
          title: "Start SOC",
          dataIndex: "startSOC",
          align: "center",
          width: 100
        },
        {
          title: "End Time",
          dataIndex: "endTime",
          sorter: (recordOne, recordTwo) => {
            let timeOne = new Date(recordOne.endTime);
            let timeTwo = new Date(recordTwo.endTime);
            return timeOne - timeTwo;
          },
          align: "center",
          width: 160
        },
        {
          title: "End SOC",
          dataIndex: "endSOC",
          align: "center",
          width: 100
        },
        {
          title: "Total Duration (min)",
          dataIndex: "totalDuration",
          align: "center",
          sorter: (recordOne, recordTwo) => recordOne.totalDuration - recordTwo.totalDuration,
          width: 120
        },
        {
          title: "Charged kWh",
          dataIndex: "chargedkWh",
          align: "center",
          width: 120
        },
        {
          title: "Location",
          dataIndex: "depot",
          sorter: (recordOne, recordTwo) => recordOne.depot.localeCompare(recordTwo.depot),
          align: "center",
          width: 200
        }
      ]
    };
  },

  components: {
    VueCsvDownloader
  },

  computed: {
    ...mapState(["CognitoUser", "CompanyMap", "SingleCompanyUser"]),

    handleData() {
      // copy data over, and sort/filter it according to requirements.
      const data = this.data;
      data
        .sort((x, y) => {
          const xval = this.$moment(x.timestampUtc).valueOf();
          const yval = this.$moment(y.timestampUtc).valueOf();
          return xval - yval;
        })
        .forEach((item, index) => {
          const startTime = this.$moment(item.startTime);
          const endTime = this.$moment(item.endTime);
          const diff = endTime.diff(startTime, "minutes");
          if (item.startTime) {
            item.startTime = this.$moment(item.startTime)
              .local()
              .format("YYYY-MM-DD HH:mm");
          }
          if (item.endTime) {
            item.endTime = this.$moment(item.endTime)
              .local()
              .format("YYYY-MM-DD HH:mm");
          }
          item.totalDuration = diff;
          item.index = index + 1;
          return item;
        });
      return data;
    },

    // function to display the list of companies user is authenticated for.
    displayCompanies() {
      let companyList = [];
      this.CompanyMap.forEach(function(value, key) {
        companyList.push(key);
      });
      return companyList.sort();
    },

    getOffsetValue() {
      if (this.SingleCompanyUser) {
        return 8;
      }
      return 0;
    }
  },

  methods: {
    getInfos(e) {
      e.preventDefault();
      this.form.validateFields(async (err, fieldsValue) => {
        if (err) {
          return;
        }
        this.data = [];
        this.loading = true;
        this.pageOffset = 0;
        const promiseArr = [];
        const rangeValue = fieldsValue["range-picker"];
        const startDay = this.$moment(rangeValue[0]).format("YYYY-MM-DD");
        const endDay = this.$moment(rangeValue[1]).format("YYYY-MM-DD");
        const startTimeUtc = this.$moment(rangeValue[0]) // convert local time "00:00" to UTC time.
          .startOf("day")
          .utc();
        const endTimeUtc = this.$moment(rangeValue[1]) // convert local time "23:59" to UTC time.
          .endOf("day")
          .utc();
        const rangeUtc = this.$moment.range(startTimeUtc, endTimeUtc).snapTo("day");
        const daysArray = Array.from(rangeUtc.by("days"));
        // check the size of the daysArray to make sure it is within the allowed range.
        if (daysArray.length > 32) {
          this.$message.error("Range over limit (1 month). Please pick a shorter duration.");
          this.loading = false;
          return;
        }
        this.csvName = `Charging_Report_${startDay}_${endDay}.csv`;
        // if no depot is selected, iterate through the array of available depots for the selected company, and query results for each.
        if (!fieldsValue.depot) {
          daysArray.forEach(day => {
            this.depotList.forEach(depot => {
              let dateTypeDepot = `${day.format("YYYY-MM-DD")}#CCR#${depot}`;
              let data = {
                dateTypeDepot: dateTypeDepot,
                startTime: startTimeUtc.toJSON(),
                endTime: endTimeUtc.toJSON(),
                busNumber: fieldsValue.busNumber,
                chargerNumber: fieldsValue.chargerNumber,
                company: this.SingleCompanyUser ? this.displayCompanies[0] : fieldsValue.company
              };
              promiseArr.push(this.sendData(data));
            });
          });
        } else {
          // else if depot is selected, only query results for the specific depot.
          daysArray.forEach(day => {
            let dateTypeDepot = `${day.format("YYYY-MM-DD")}#CCR#${fieldsValue.depot}`;
            let data = {
              dateTypeDepot,
              startTime: startTimeUtc.toJSON(),
              endTime: endTimeUtc.toJSON(),
              busNumber: fieldsValue.busNumber,
              chargerNumber: fieldsValue.chargerNumber,
              company: this.SingleCompanyUser ? this.displayCompanies[0] : fieldsValue.company
            };
            promiseArr.push(this.sendData(data));
          });
        }
        try {
          let dataArr = await Promise.all(promiseArr);
          let data = dataArr.flat(Infinity);
          // check if no data is returned; display a message to user in that case.
          if (!data.length) {
            throw new Error("No data available for selected fields!");
          }
          this.data = data;
          this.numberOfRows = this.data.length;
        } catch (error) {
          this.$message.error(error.message);
          this.loading = false;
          return;
        }
        this.loading = false;
        this.downloadDisabled = false;
      });
    },

    async sendData(data) {
      try {
        // add region to the query parameter before making the API call.
        data.region = this.CompanyMap.get(data.company).region;
        let response = await this.$axios.get("https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/chargingus", {
          params: data
        });
        let items = response.data.Items;
        return Promise.resolve(items);
      } catch (error) {
        // if no response is available, means it is a network error.
        if (!error.response) {
          return Promise.reject(new Error("Network Error. Please try again!"));
        } else {
          let response = error.response;
          if (response.status == 400) {
            return Promise.reject(response.data.message);
          }
        }
      }
    },

    generateCSVFields(company) {
      let fieldsArray = [];
      fieldsArray = this.columns.map(item => {
        return item.dataIndex;
      });
      if (this.CompanyMap.get(company).region == "sa-east-1") {
        fieldsArray.push("chargingGunOneResetCount");
        fieldsArray.push("chargingGunTwoResetCount");
        fieldsArray.push("chargingTimeElapsed");
      }
      // add start and end charger status to both the regions.
      fieldsArray.push("startStatus");
      fieldsArray.push("endStatus");
      this.fields = fieldsArray;
    },

    onDateChange() {
      this.downloadDisabled = true;
    },

    onCompanyChange(value) {
      this.form.resetFields(["depot"]);
      if (!value) {
        this.depotDisabled = true;
      } else {
        this.depotDisabled = false;
        this.depotList = this.CompanyMap.get(value).depots.sort();
        this.generateCSVFields(value);
      }
    },

    onTableChange(pagination, filters, sorter, { currentDataSource }) {
      // update the current number of rows in the table, and the page offset.
      this.pageOffset = (pagination.current - 1) * pagination.pageSize;
      this.numberOfRows = currentDataSource.length;
    }
  },

  created() {
    this.onCompanyChange(this.displayCompanies[0]);
  }
};
</script>
